import { canonicalizeFiscalYear } from "../utils/fiscalYearMatch";
import { buildCurrentAopProgramNameSet } from "../utils/currentAopByProgram";


import { apiFetch } from "./apiFetch";

/**
 * Load Current AOP By Program names (SOP for Operating Plan Current FY).
 * @returns {Promise<Set<string>>}
 */
export async function fetchCurrentAopProgramNames({ serverUrl, account_id }) {
  if (!serverUrl || !account_id) {
    throw new Error("serverUrl and account_id are required.");
  }
  const [settingsResp, sopResp] = await Promise.all([
    apiFetch(serverUrl + "/getOperatingPlanSettings", {
      method: "POST",
      body: JSON.stringify({ account_id }),
    }),
    apiFetch(serverUrl + "/getSOP", {
      method: "POST",
      body: JSON.stringify({ account_id }),
    }),
  ]);
  if (!settingsResp.ok) {
    const text = await settingsResp.text();
    throw new Error(text || "Failed to load Operating Plan settings.");
  }
  if (!sopResp.ok) {
    const text = await sopResp.text();
    throw new Error(text || "Failed to load SOP.");
  }
  const settings = await settingsResp.json().catch(() => ({}));
  const sopData = await sopResp.json().catch(() => []);
  const currentFy =
    canonicalizeFiscalYear((settings && settings.current_fy) || "") ||
    canonicalizeFiscalYear(String(new Date().getFullYear()));
  return buildCurrentAopProgramNameSet(Array.isArray(sopData) ? sopData : [], currentFy);
}
